import { TimelineFiling } from "store/apis/filingsTimeline";

/**
 * `uuid` identifies a filing but is not unique within a response: two filings
 * for the same entity, product, season and state share one. Backend measured
 * 1,463 of 1,939 rows sharing a uuid with at least one other row, so this is
 * the normal case, not an edge case. Selecting on `uuid` alone selects every
 * row that shares it — the three Estimated Tax dots light up together.
 */
export const getFilingRowKey = (
  filing: TimelineFiling,
  index: number
): string => `${filing.filing_id || filing.uuid}#${index}`;
